<template>
    <div class="md:mt-8 pb-8 border-b border-[#E5E7EB]">
      <fwb-heading tag="h3" class="only-dest font-medium text-xl">
        Servicios
      </fwb-heading>
  
      <div class="md:mt-4">
        <ul class="grid grid-cols-2 md:grid-cols-4 gap-4">
          <li
            v-for="item in sortedList"
            :key="item.id"
            class="flex items-start"
          >
            <!-- <div v-html="item.catalogue_services.icon" /> -->
            <svg class="w-4 h-4 shrink-0" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
              <path d="M11.1973 3.26953C11.3431 3.1237 11.498 3.1237 11.6621 3.26953L12.4277 4.0625C12.5918 4.20833 12.5918 4.36328 12.4277 4.52734L4.22461 12.7305C4.07878 12.8763 3.92383 12.8763 3.75977 12.7305L0.123047 9.06641C-0.0410156 8.92057 -0.0410156 8.76562 0.123047 8.60156L0.888672 7.83594C1.05273 7.67188 1.20768 7.67188 1.35352 7.83594L4.00586 10.4883L11.1973 3.26953Z" fill="#FF4265"/>
            </svg>
            <span class="ml-2 max-w-[110px] break-words whitespace-normal text-left"> {{ item.catalogue_services.name }} </span>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <script setup>
  import { computed } from "vue";
  import { FwbHeading } from "flowbite-vue";
  
  const props = defineProps({
    list: {
      type: Array,
      required: true,
    },
  });

  const sortedList = computed(() => {
    if (!Array.isArray(props.list)) return [];
    return [...props.list].sort((a, b) => {
      const nameA = a.catalogue_services?.name || '';
      const nameB = b.catalogue_services?.name || '';
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
    });
  });
  </script>
